// ============================================
// COOKIE БАННЕР
// ============================================
document.addEventListener('DOMContentLoaded', function() {
    const cookieBanner = document.getElementById('cookieBanner');
    const cookieAccept = document.getElementById('cookieAccept');
    const cookieDecline = document.getElementById('cookieDecline');

    // Проверяем, есть ли баннер на странице
    if (!cookieBanner) return;

    // Проверяем, было ли уже дано согласие
    function checkCookieConsent() {
        const consent = localStorage.getItem('cookieConsent');
        if (consent === 'accepted' || consent === 'declined') {
            cookieBanner.classList.remove('show');
            return true;
        }
        return false;
    }

    // Показываем баннер, если согласия ещё нет
    if (!checkCookieConsent()) {
        setTimeout(() => {
            cookieBanner.classList.add('show');
        }, 1000);
    }

    // Принять cookie
    if (cookieAccept) {
        cookieAccept.addEventListener('click', function() {
            localStorage.setItem('cookieConsent', 'accepted');
            cookieBanner.classList.remove('show');
            // Можно добавить событие для аналитики
            console.log('✅ Cookie приняты');
        });
    }

    // Отказаться от cookie
    if (cookieDecline) {
        cookieDecline.addEventListener('click', function() {
            localStorage.setItem('cookieConsent', 'declined');
            cookieBanner.classList.remove('show');
            console.log('❌ Cookie отклонены');
        });
    }
});
